import { ButtonLink } from '@/components/ui/Button';
import { featuredSlug } from '@/content/registry';
import { useDocumentTitle } from '@/lib/hooks';
import styles from './StaticPage.module.css';

export function NotFoundPage() {
  useDocumentTitle('Not found — Are We Compatible?');

  return (
    <div className={styles.page}>
      <div className={styles.notFound}>
        <p className={styles.eyebrow}>404</p>
        <h1 className={styles.title}>There is nothing at this address.</h1>
        <p className={styles.lede}>
          If you were given a card, it is worth checking the link against what is printed
          on it &mdash; a single character is usually the culprit.
        </p>

        <div className={styles.actions}>
          <ButtonLink to={`/${featuredSlug}`} size="large" withArrow>
            Go to the profile
          </ButtonLink>
          <ButtonLink to="/" variant="secondary" size="large">
            Back to the start
          </ButtonLink>
        </div>
      </div>
    </div>
  );
}
